var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{attrs:{"id":_vm.canvaId}}),_c('LoadingCover',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],attrs:{"spinner":"dotsbar"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }